class CookieConsentManager {
  constructor() {
    if (CookieConsentManager.instance) {
      return CookieConsentManager.instance
    }

    this.consentData = {
      necessary: true,
      preferences: true,
      statistics: true,
      marketing: true,
    }

    CookieConsentManager.instance = this
  }

  static getInstance() {
    if (!CookieConsentManager.instance) {
      CookieConsentManager.instance = new CookieConsentManager()
    }
    return CookieConsentManager.instance
  }

  init(useConsentManager) {
    if (!useConsentManager) return

    this.detectConsentManager()

    window.addEventListener(
      'CookiebotOnConsentReady',
      () => {
        this.updateConsentDataFromCookieBot()
      },
      false
    )
  }

  detectConsentManager() {
    this.detectStart = true
    if (typeof CookieConsent !== 'undefined' && CookieConsent.consent) {
      //CookieBot
      this.updateConsentDataFromCookieBot()
    } else if (window.getCkyConsent) {
      //CookieYes
      this.updateConsentDataFromCookieYes()
    } else if (typeof OnetrustActiveGroups !== 'undefined' && OnetrustActiveGroups) {
      //OneTrust
      this.updateConsentDataFromOnetrust()
    } else if (typeof PrivacyManagerAPI !== 'undefined' && PrivacyManagerAPI) {
      //TrustArc
      this.updateConsentDataFromTrustArc()
    } else {
      if (!this.detectStart) {
        setTimeout((_) => this.detectConsentManager(), 1000)
      }
    }
  }

  updateConsentDataFromTrustArc() {
    function isCategoryConsented(categories, categoryId) {
      return categories.includes(categoryId)
    }

    const categories = PrivacyManagerAPI.callApi('getGDPRConsentDecision', self.location.host).consentDecision.split(',')
    const necessaryConsent = true
    const performanceConsent = isCategoryConsented('C0002') || isCategoryConsented('2')
    const functionalConsent = isCategoryConsented('C0003') || isCategoryConsented('2')
    const advertisingConsent = isCategoryConsented('C0004') || isCategoryConsented('3')

    this.consentData = {
      necessary: necessaryConsent,
      preferences: functionalConsent,
      statistics: performanceConsent,
      marketing: advertisingConsent,
    }
  }

  updateConsentDataFromOnetrust() {
    function isCategoryConsented(categories, categoryId) {
      return categories.includes(categoryId)
    }

    const categories = OnetrustActiveGroups.split(',')
    const necessaryConsent = isCategoryConsented('C0001') || isCategoryConsented('1')
    const performanceConsent = isCategoryConsented('C0002') || isCategoryConsented('2')
    const functionalConsent = isCategoryConsented('C0003') || isCategoryConsented('3')
    const targetingConsent = isCategoryConsented('C0004') || isCategoryConsented('4')

    this.consentData = {
      necessary: necessaryConsent,
      preferences: functionalConsent,
      statistics: performanceConsent,
      marketing: targetingConsent,
    }
  }

  updateConsentDataFromCookieYes() {
    const consent = getCkyConsent()
    const categories = consent.categories

    const mapping = {
      functional: 'preferences',
      analytics: 'statistics',
      performance: 'statistics',
      advertisement: 'marketing',
      necessary: 'necessary',
    }

    this.consentData = this.mapCategories(categories, mapping)
  }

  updateConsentDataFromCookieBot() {
    this.consentData = CookieConsent.consent
    //{marketing: true, necessary: true, preferences: true, statistics: true}
  }

  setLocalStorageItem(key, value, category = 'necessary') {
    if (this.hasConsent(category)) localStorage.setItem(key, value)
  }

  hasConsent(category) {
    return this.consentData[category] || false
  }

  setConsent(category, consent) {
    this.consentData[category] = consent

    const fullEventName = 'trueengage:consent_changed'
    const event = new CustomEvent(fullEventName, { detail: this.consentData })
    document.dispatchEvent(event)
  }

  mapCategories(categories, mapping) {
    const structure = {
      necessary: true,
      preferences: true,
      statistics: true,
      marketing: true,
    }
    let result = {}
    for (let key in structure) {
      result[key] = structure[key]
    }
    for (let key in categories) {
      if (mapping[key]) {
        result[mapping[key]] = categories[key]
      }
    }
    return result
  }
}

const cookieConsentManager = CookieConsentManager.getInstance()
export default cookieConsentManager
